import styled from 'styled-components/macro'

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`

export default Wrapper
